import { render } from "./ChecklistList.vue?vue&type=template&id=36179ef0&scoped=true"
import script from "./ChecklistList.vue?vue&type=script&lang=js"
export * from "./ChecklistList.vue?vue&type=script&lang=js"

import "./ChecklistList.vue?vue&type=style&index=0&id=36179ef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36179ef0"]])

export default __exports__